module.exports = __webpack_public_path__ + "static/ubuntu-regular-5b23eeb3a32b30e91682d601535d2a89.woff2";